<script>
import _ from 'lodash'
import { exportTemplateAsCSV as createCsv } from '../../../utils/fileUtils'
import { getAllData } from '../../../utils/indexedDbUtils'
import { toggleInArray } from '../../../utils/utils'
import Card from '../../../slds/Card'
import FilePicker from '../../../slds/FilePicker'
import Modal from '../../../Modal'
import Spinner from '../../../Spinner'
import TabSet from '../../../slds/tabs/TabSet'
import Tab from '../../../slds/tabs/Tab'
import OutputField from '../../../slds/OutputField'
import IncludedFilter from './../../filters/IncludedFilter.vue'

export default {
  components: {
    Tab,
    TabSet,
    Card,
    FilePicker,
    Modal,
    Spinner,
    OutputField,
    IncludedFilter
  },
  props: {
    brands: Array,
    canExcludeVin: Boolean,
    editable: Boolean,
    informativeCampaign: Boolean,
    mvs: Object,
    mvsToExclude: Object,
    vin: [ Array, Object ],
    vinToExclude: [ Array, Object ],
    zipCodes: [Array, Object]
  },
  async created () {
    this.openTab = this.mvs && Object.keys(this.mvs).length ? 'ZIP' : 'VIN'
    this.localValue = _.cloneDeep(this.zipCodes)
    console.log(this.localValue)
    this.zipCodeRegexByMarket = this.$store.getters['settings/settings'].zipCodeRegex
    this.mvsInvertedMap = (await getAllData('mvs')).reduce((acc, val) => {
      acc[val.mvs] = val
      return acc
    }, {})

    this.localMvs = _.cloneDeep(this.mvs)
    this.localMvsToExclude = _.cloneDeep(this.mvsToExclude)
    this.localVin = _.cloneDeep(this.vin)
    this.localVinToExclude = _.cloneDeep(this.vinToExclude)
    this.loading = false
  },
  data () {
    return {
      localValue: {},
      zipCodeRegexByMarket: {},
      loading: true,
      localMvs: {},
      localMvsToExclude: {},
      localVin: {},
      localVinToExclude: {},
      mvsInvertedMap: {},
      openTab: ''
    }
  },
  methods: {
    clearMVS (brand) {
      this.localMvs[brand] = []
    },
    downloadTemplate (template) {
      const type = template.toUpperCase()
      createCsv(`EMPTY_${type}_CSV`, `TEMPLATE_${type}.csv`)
    },
    async handleExcludedVINUpload (event) {
      const { content } = event

      try {
        const vinList = content.split(/\r?\n/)
        if (!this.localVinToExclude) {
          this.localVinToExclude = [...vinList]
        } else {
          this.localVinToExclude.push(...vinList)
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error)
      }
    },
    async handleIncludedVINMVSUpload (event, filterType) {
      const { content } = event

      try {
        if (filterType === 'mvs') {
          if (!this.localMvs) {
            this.localMvs = {}
            if (this.selectedBrands[0] === 'All') {
              this.brands.forEach(brand => {
                this.localMvs[brand.value] = []
              })
            } else {
              this.selectedBrands.forEach(brand => {
                this.localMvs[brand.value] = []
              })
            }
          } else {
            if (Object.keys(this.localMvs).length === 1 && 'All' in this.localMvs) {
              this.brands.forEach(brand => {
                this.localMvs[brand.value] = []
              })
            }
          }

          const mvsList = content.split(/\r?\n/)
          const mvsNotFound = []
          mvsList.forEach(mvs => {
            if (mvs.trim().length > 0) {
              const mvsObject = this.mvsInvertedMap[mvs.trim()]
              if (mvsObject && this.localMvs[mvsObject.brand]) {
                this.localMvs[mvsObject.brand].push(mvs.trim())
              } else {
                mvsNotFound.push(`<li>- ${mvs}</li>`)
              }
            }
          })

          if (mvsNotFound.length > 0) {
            this.showToast('warning',
              this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarning'),
              'HTML',
              this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarningText', { list: mvsNotFound.join('') }))
          } else {
            this.showToast('success', this.$t('general.success'), 'text', this.$t('message.update'))
          }

          this.$forceUpdate()
        } else {
          const vinList = content.split(/\r?\n/).filter(v => !!v)
          if (!this.localVin) {
            this.localVin = vinList
          } else {
            this.localVin.push(...vinList)
          }
          // Removed duplicates
          this.localVin = Array.from(new Set(this.localVin))
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error)
      }
    },
    async handleExcludedMVSUpload (event) {
      const { content } = event

      if (!this.localMvsToExclude) {
        this.localMvsToExclude = {}
        if (this.selectedBrands[0] === 'All') {
          this.brands.forEach(brand => {
            this.localMvsToExclude[brand.value] = []
          })
        } else {
          this.selectedBrands.forEach(brand => {
            this.localMvsToExclude[brand.value] = []
          })
        }
      } else {
        if (Object.keys(this.localMvsToExclude).length === 1 && 'All' in this.localMvsToExclude) {
          this.brands.forEach(brand => {
            this.localMvsToExclude[brand.value] = []
          })
        }
      }

      const mvsList = content.split(/\r?\n/)
      const mvsNotFound = []
      mvsList.forEach(mvs => {
        if (mvs.trim().length > 0) {
          const mvsObject = this.mvsInvertedMap[mvs.trim()]
          if (mvsObject && this.localMvsToExclude[mvsObject.brand]) {
            if (!this.localMvsToExclude[mvsObject.brand].includes(mvs.trim())) {
              this.localMvsToExclude[mvsObject.brand].push(mvs.trim())
            }
          } else {
            mvsNotFound.push(`<li>- ${mvs}</li>`)
          }
        }
      })

      if (mvsNotFound.length > 0) {
        this.showToast('warning',
          this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarning'),
          'HTML',
          this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarningText', { list: mvsNotFound.join('') }))
      } else {
        this.showToast('success', this.$t('general.success'), 'text', this.$t('message.update'))
      }

      this.$forceUpdate()
    },
    removeMvs (brand, mvs) {
      toggleInArray(this.localMvs[brand.value], mvs)
    },
    removeMvsToExclude (brand, mvs) {
      toggleInArray(this.localMvsToExclude[brand.value], mvs)
    },
    removeVin (vin) {
      toggleInArray(this.localVin, vin)
    },
    removeVinToExclude (vin) {
      toggleInArray(this.localVinToExclude, vin)
    },
    save () {
      this.$emit('input', _.cloneDeep(this.localValue))
      this.$emit('save', {
        data: {
          mvs: _.cloneDeep(this.localMvs),
          mvsToExclude: _.cloneDeep(this.localMvsToExclude),
          vin: _.cloneDeep(this.localVin),
          vinToExclude: _.cloneDeep(this.localVinToExclude),
          zipCodes: _.cloneDeep(this.localValue)
        }
      })
      this.$emit('close')
    },
    getItemsValidation (market) {
      const regex = this.zipCodeRegexByMarket[market]
      return [{
        message: this.$t('validation.custom.invalidZipCodeForMarket'),
        name: 'regex',
        regex: new RegExp(regex)
      }]
    },
    handleUpload (event) {
      const markets = Object.keys(this.localValue)
      const { content } = event

      try {
        const rows = content.split(/\r?\n/)
        const invalidZipCodes = []
        rows.forEach(row => {
          if (row) {
            let [ market, zipCode ] = row.split(',')
            const market_per_code = this.$store.getters['settings/settings'].market_per_code
            for(let market_num in market_per_code) {
              if (market_per_code[market_num] == market) { //If zip is IT,GR...etc instead of 1000,1001...etc, then convert it to number
                market = market_num
                break;
              }
            }
            // Check if zip code matches market's regex
            if (markets.includes(market)) {
              const re = new RegExp(this.zipCodeRegexByMarket[market])
              if (re.test(zipCode)) {
                this.localValue[market].push(zipCode)
              } else {
                invalidZipCodes.push(`<li>- ${market} - ${zipCode}</li>`)
              }
            }
          }
        })

        // Remove duplicates
        Object.keys(this.localValue).forEach(market => {
          this.localValue[market] = Array.from(new Set(this.localValue[market]))
        })

        if (invalidZipCodes.length) {
          this.showToast('warning',
            this.$t('campaignDesigner.targetDefinition.manageZipCodes.invalidZipCodesWarning'),
            'HTML',
            this.$t('campaignDesigner.targetDefinition.manageZipCodes.invalidZipCodesWarningText', { list: invalidZipCodes.join('') }))
        } else {
          this.showToast('success', this.$t('general.success'), 'text', this.$t('message.update'))
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error)
      }
    },
    removeZipCode (market, zipCode) {
      toggleInArray(this.localValue[market], zipCode)
    },
    downloadZIPTemplate () {
      createCsv(`EMPTY_ZIP_CODES_CSV`, `TEMPLATE_ZIP_CODES.csv`)
    }
  },
  computed: {
    userCanIncludeMVS () {
      if (this.editable) {
        if (this.informativeCampaign) {
          return true
        } else {
          return Object.values(this.localMvs).flat().length === 0
        }
      } else {
        return false
      }
    }
  },
  watch: {
    value (val) {
      this.localValue = _.cloneDeep(val)
    },
    mvs (val) {
      this.localMvs = _.cloneDeep(val)
    },
    mvsToExclude (val) {
      this.localMvsToExclude = _.cloneDeep(val)
    },
    vin (val) {
      this.localVin = _.cloneDeep(val)
    },
    vinToExclude (val) {
      this.localVinToExclude = _.cloneDeep(val)
    }
  }
}
</script>
<template>
  <Modal
    directional
    @close="$emit('close')"
    :height="localMvs && Object.keys(localMvs).length ? '90vh' : '40vh'"
    :title="'Manage ZIP/VIN'">
    <Spinner v-if="loading" />

    <TabSet tab-set-id="manage_zip_vin" v-else>
      <Tab :label="'ZIP'" tab-set-id="manage_zip_vin">
        <Card additional-classes="slds-card_boundary" has-empty-title>
          <template v-if="editable">
            <div class="slds-button-group" role="group" slot="actions">
              <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleUpload" />
              <button class="slds-button slds-button_neutral" @click="downloadTemplate('zip_codes')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
            </div>

            <template v-for="market in Object.keys(localValue)">
              <IncludedFilter
                :items-validation="getItemsValidation(market)"
                :label="$t(`markets.${market}`)"
                :key="market"
                input-type="text"
                ref="child"
                v-if="editable"
                v-model="localValue[market]" />
            </template>
          </template>

          <template v-else>
            <Card
              :title="$t(`markets.${market}`)"
              :key="market"
              additional-classes="slds-card_boundary"
              v-for="market in Object.keys(localValue)">

              <OutputField :value="localValue[market]" type="array" />

            </Card>
          </template>
        </Card>
      </Tab>

      <Tab :label="$t('campaignDesigner.targetDefinition.vin')" tab-set-id="manage_zip_vin">
        <!-- Included VIN -->
        <Card
          additional-classes="slds-card_boundary height-reset"
          :title="$t('campaignDesigner.targetDefinition.includedVIN', {count: localVin ? localVin.length : 0})"
          :show-body="!!(localVin && localVin && localVin.length)">

          <div class="slds-button-group" role="group" v-if="editable && informativeCampaign" slot="actions">
            <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleIncludedVINMVSUpload($event, 'vin')" />
            <button class="slds-button slds-button_neutral" @click="downloadTemplate('vin')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
          </div>

          <ul class="slds-listbox slds-listbox_horizontal" role="listbox" aria-label="Selected Options:" aria-orientation="horizontal" >
            <li class="slds-listbox-item" role="presentation" v-for="(v, index) in localVin" :key="index">
              <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
                <span class="slds-pill__label">{{v}}</span>
                <span class="slds-icon_container slds-pill__remove" :title="$t('action.remove')" @click="removeVin(v)" v-if="editable && (informativeCampaign || localVin.length > 1)">
                  <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                    <use xlink:href="../../../../assets/symbols.svg#close"></use>
                  </svg>
                </span>
              </span>
            </li>
          </ul>
        </Card>

        <!-- Excluded VIN -->
        <Card additional-classes="slds-card_boundary height-reset"
          :title="$t('campaignDesigner.targetDefinition.excludedVIN', {count: localVinToExclude ? localVinToExclude.length : 0})">
          <div class="slds-button-group" role="group" v-if="editable" slot="actions">
            <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleExcludedVINUpload" />
            <button class="slds-button slds-button_neutral" @click="downloadTemplate('vin')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
          </div>
          <ul class="slds-listbox slds-listbox_horizontal slds-m-top--medium" role="listbox" aria-orientation="horizontal" v-if="localVinToExclude && localVinToExclude.length">
            <li class="slds-listbox-item" role="presentation" v-for="(vin, index) in localVinToExclude" :key="index">
              <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
                <span class="slds-pill__label">{{vin}}</span>
                <span class="slds-icon_container slds-pill__remove" :title="$t('action.remove')" @click="removeVinToExclude(vin)" v-if="editable">
                  <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                    <use xlink:href="../../../../assets/symbols.svg#close"></use>
                  </svg>
                </span>
              </span>
            </li>
          </ul>
        </Card>
      </Tab>
    </TabSet>

    <template slot="footer" v-if="editable">
      <button class="slds-button slds-button_neutral" @click="$emit('close')">{{$t('action.cancel')}}</button>
      <button class="slds-button slds-button_brand" @click="save">{{$t('action.save')}}</button>
    </template>
  </Modal>
</template>
<style lang="scss" scoped>
  svg {
    cursor: pointer;
  }
</style>
